// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Realtime overall status of a `Trip` (depends on `PTRideLeg::serviceJourney` status).
 * @export
 * @interface TripStatus
 */
export interface TripStatus {
    /**
     * false: Planned connection; true: Realtime alternative
     * @type {boolean}
     * @memberof TripStatus
     */
    alternative: boolean;
    /**
     * Text intended for passengers about an alternative Trip, relates to `alternative`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof TripStatus
     */
    alternativeFormatted?: string;
    /**
     * true: Trip is possible to ride based on the current realtime situation (related to `Trip::serviceCalendar`, `PTRideLeg::reachable`, etc); false: **Fatal resp. not rideable as a 'whole' Trip' anymore** (aka OJP infeasible, OSDM invalid). Important: if this valid toggles from true to false, the passenger might not be able to perform his Trip, by means individual re-planning might be necessary.
     * @type {boolean}
     * @memberof TripStatus
     */
    valid: boolean;
    /**
     * `PTRideLeg` cancelled (de:Ausfall), relates to `cancelledFormatted`.
     * @type {boolean}
     * @memberof TripStatus
     */
    cancelled: boolean;
    /**
     * If `cancelled` or `partiallyCancelled` is true, enduser info about `Trip`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof TripStatus
     */
    cancelledFormatted?: string;
    /**
     * `PTRideLeg` partially cancelled (de:Teilausfall), relates to `cancelledFormatted`.
     * @type {boolean}
     * @memberof TripStatus
     */
    partiallyCancelled: boolean;
    /**
     * Contains at least one platform change (de:Gleis-/Kante-/Steg-Änderung) on any `PTRideLeg`.
     * @type {boolean}
     * @memberof TripStatus
     */
    quayChanged: boolean;
    /**
     * Contains at least one delay (de:Verspätung) on any `PTRideLeg`.
     * @type {boolean}
     * @memberof TripStatus
     */
    delayed: boolean;
    /**
     * Contains at least one unknown delay (de:Unbestimmte Verspätung) on any `PTRideLeg`.
     * @type {boolean}
     * @memberof TripStatus
     */
    delayedUnknown: boolean;
    /**
     * If not true, changing `PTRideLeg's` is not guaranteed (de:Anschluss gehalten). If true, the connection is guaranteed but might require a quick transfer.
     * @type {boolean}
     * @memberof TripStatus
     */
    reachable: boolean;
    /**
     * Contains at least one `StopPlace` which is not serviced (de:ausserordentliche Durchfahrt) on any `PTRideLeg`. Releates to `ScheduledStopPoint::stopStatus==NOT_SERVICED`.
     * @type {boolean}
     * @memberof TripStatus
     */
    notServicedStopPoints: boolean;
    /**
     * true: contains additional `StopPlace` resp. `ScheduledStopPoint` (de:ausserordentlicher Halt). Releates to `ScheduledStopPoint::stopStatus==UNPLANNED` and `ServiceAlteration::unplannedStopPointsFormatted` (aka OJP Unplanned).
     * @type {boolean}
     * @memberof TripStatus
     */
    unplannedStopPoints: boolean;
    /**
     * Hint whether at least one vehicle transfer is critical for passengers with a handicap, related to `includeAccessibility` other than `ALL` and `PTRideLeg::navigationPathAssignment` (otherwise null).
     * @type {boolean}
     * @memberof TripStatus
     */
    mobilityRestrictedTransferCritical?: boolean;
}

/**
 * Check if a given object implements the TripStatus interface.
 */
export function instanceOfTripStatus(value: object): value is TripStatus {
    if (!('alternative' in value) || value['alternative'] === undefined) return false;
    if (!('valid' in value) || value['valid'] === undefined) return false;
    if (!('cancelled' in value) || value['cancelled'] === undefined) return false;
    if (!('partiallyCancelled' in value) || value['partiallyCancelled'] === undefined) return false;
    if (!('quayChanged' in value) || value['quayChanged'] === undefined) return false;
    if (!('delayed' in value) || value['delayed'] === undefined) return false;
    if (!('delayedUnknown' in value) || value['delayedUnknown'] === undefined) return false;
    if (!('reachable' in value) || value['reachable'] === undefined) return false;
    if (!('notServicedStopPoints' in value) || value['notServicedStopPoints'] === undefined) return false;
    if (!('unplannedStopPoints' in value) || value['unplannedStopPoints'] === undefined) return false;
    return true;
}

export function TripStatusFromJSON(json: any): TripStatus {
    return TripStatusFromJSONTyped(json, false);
}

export function TripStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'alternative': json['alternative'],
        'alternativeFormatted': json['alternativeFormatted'] == null ? undefined : json['alternativeFormatted'],
        'valid': json['valid'],
        'cancelled': json['cancelled'],
        'cancelledFormatted': json['cancelledFormatted'] == null ? undefined : json['cancelledFormatted'],
        'partiallyCancelled': json['partiallyCancelled'],
        'quayChanged': json['quayChanged'],
        'delayed': json['delayed'],
        'delayedUnknown': json['delayedUnknown'],
        'reachable': json['reachable'],
        'notServicedStopPoints': json['notServicedStopPoints'],
        'unplannedStopPoints': json['unplannedStopPoints'],
        'mobilityRestrictedTransferCritical': json['mobilityRestrictedTransferCritical'] == null ? undefined : json['mobilityRestrictedTransferCritical'],
    };
}

  export function TripStatusToJSON(json: any): TripStatus {
      return TripStatusToJSONTyped(json, false);
  }

  export function TripStatusToJSONTyped(value?: TripStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alternative': value['alternative'],
        'alternativeFormatted': value['alternativeFormatted'],
        'valid': value['valid'],
        'cancelled': value['cancelled'],
        'cancelledFormatted': value['cancelledFormatted'],
        'partiallyCancelled': value['partiallyCancelled'],
        'quayChanged': value['quayChanged'],
        'delayed': value['delayed'],
        'delayedUnknown': value['delayedUnknown'],
        'reachable': value['reachable'],
        'notServicedStopPoints': value['notServicedStopPoints'],
        'unplannedStopPoints': value['unplannedStopPoints'],
        'mobilityRestrictedTransferCritical': value['mobilityRestrictedTransferCritical'],
    };
}

